import React from 'react';
import styled from 'styled-components';
import { getLocalStorageValue } from 'Utils/UtilityFunctions';
import { secondaryFont, wMBold } from 'Utils/utilsStyle';
import PeopleWidgetWithOutHolo from './PeopleWidgetWithOutHolo';

const Wrapper = styled.div`
display: flex;
align-items: center;
background-color: #F8F8F8;
padding: 12px 10px;
.username {
  width: calc(100% - 60px);
  font-family: ${secondaryFont};
  font-weight: ${wMBold};
  font-size: 16px;
  line-height: 18px;
  margin-left: 15px;
}
`;

const MenuUserCard = function MenuUserCard() {
  const username = getLocalStorageValue('fullname');
  const personImage = getLocalStorageValue('profilePic');
  const personalityTypes = getLocalStorageValue('personalitycolors');
  return (
    <Wrapper>
      <PeopleWidgetWithOutHolo
        logo={personImage || ''}
        diameter="60px"
        diameterSm="60px"
        diameterXsm="60px"
        margin="0"
        wrapperColor={personalityTypes || ''}
      />
      <h1 className="username text-truncate-three-line">{username}</h1>
    </Wrapper>
  );
};
export default MenuUserCard;
